exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adVisitedLabel__visitedLabel___1oQfn, .adVisitedLabel__visitedLabelMobile___3KDRF {\n  position: absolute;\n  color: #ffffff;\n  line-height: initial;\n  left: 15px;\n  top: 15px;\n  z-index: 2;\n  min-width: 71px;\n  min-height: 20px;\n  text-align: center;\n  font-size: 12px;\n  padding: 5.5px 9px;\n  text-transform: uppercase;\n  border-radius: 2px; }\n\n.adVisitedLabel__visitedLabel___1oQfn {\n  top: unset;\n  right: unset;\n  bottom: 15px;\n  left: 15px;\n  background-color: rgba(0, 0, 0, 0.5); }\n\n.adVisitedLabel__visitedLabelMobile___3KDRF {\n  left: unset;\n  background-color: rgba(0, 0, 0, 0.5);\n  min-width: 35px;\n  min-height: 10px;\n  top: unset;\n  right: unset;\n  bottom: 8px;\n  left: 7px;\n  font-size: 10px;\n  padding: 5.5px 3px; }\n", ""]);

// exports
exports.locals = {
	"visitedLabel": "adVisitedLabel__visitedLabel___1oQfn",
	"visitedLabelMobile": "adVisitedLabel__visitedLabelMobile___3KDRF"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/AdCard/AdVisitedLabel/adVisitedLabel.scss
// module id = 3935
// module chunks = 6